import type {
  DraftPickStateResponse,
  DraftPickStateResponsePagedData,
} from '@on3/api';
import { Text } from '@public/components/UI/Typography/Text';

import styles from './PicksByState.module.scss';

interface IPicksByStateProps {
  statePicks: DraftPickStateResponsePagedData;
  picksTitle?: string;
}

export const PicksByState = ({
  statePicks,
  picksTitle,
}: IPicksByStateProps) => {
  const { list: statePicksList } = statePicks;

  return (
    <section>
      <header className={styles.header}>
        <h2 className={styles.stateTitle}>{picksTitle}</h2>
      </header>
      <ol className={styles.stateContainer}>
        {statePicksList?.slice(0, 8).map((item: DraftPickStateResponse) => {
          const { count, state } = item;

          return (
            <li className={styles.stateWrapper} key={state?.key}>
              <Text className={styles.abbreviation}>
                <abbr className={styles.abbrItem} title={state?.name ?? ''}>
                  {state?.abbreviation ?? '-'}
                </abbr>
              </Text>
              <Text className={styles.count}>{count ?? '-'}</Text>
            </li>
          );
        })}
      </ol>
    </section>
  );
};
